/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Harden_Output6Inputs */

const en_svc_full_stack_web_apps_harden_output6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live & monitored app`)
};

const ar_svc_full_stack_web_apps_harden_output6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطبيق مباشر ومراقب`)
};

const bn_svc_full_stack_web_apps_harden_output6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লাইভ ও মনিটরড অ্যাপ`)
};

const de_svc_full_stack_web_apps_harden_output6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live- und überwachte App`)
};

const es_svc_full_stack_web_apps_harden_output6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicación en vivo y monitoreada`)
};

const fr_svc_full_stack_web_apps_harden_output6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application en direct et surveillée`)
};

const pt_svc_full_stack_web_apps_harden_output6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicativo ao vivo e monitorado`)
};

const zh_svc_full_stack_web_apps_harden_output6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时和监控应用程序`)
};

const tr_svc_full_stack_web_apps_harden_output6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı ve izlenen uygulama`)
};

const ru_svc_full_stack_web_apps_harden_output6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приложение в реальном времени и под наблюдением`)
};

const pl_svc_full_stack_web_apps_harden_output6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikacja na żywo i monitorowana`)
};

/**
* | output |
* | --- |
* | "Live & monitored app" |
*
* @param {Svc_Full_Stack_Web_Apps_Harden_Output6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_harden_output6 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Harden_Output6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Harden_Output6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_harden_output6(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_harden_output6(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_harden_output6(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_harden_output6(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_harden_output6(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_harden_output6(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_harden_output6(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_harden_output6(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_harden_output6(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_harden_output6(inputs)
	return en_svc_full_stack_web_apps_harden_output6(inputs)
});
export { svc_full_stack_web_apps_harden_output6 as "svc_full-stack-web-apps_HARDEN_output" }